// @flow
import React, { type ChildrenArray } from 'react';
import { defineMessages, injectIntl, type IntlShape } from 'react-intl';
import { applyModifiers } from '../../utils';

const STYLE_PREFIX = 'c-field';

const ACTIVE_CLASS = 'is-current';

const INVALID_CLASS = 'is-invalid';

const messages = defineMessages({
  optional: { id: 'field.optional', defaultMessage: '(Optional)' },
});

type Props = {
  active: boolean,
  children: ChildrenArray<*>, // Props Node fails flow type checking on line 43. Set to array of any element.
  floatLabel: boolean,
  hiddenLabel: boolean,
  id: string,
  intl: IntlShape,
  invalid: boolean,
  label: string,
  modifiers: Modifiers,
  required: boolean,
  touched: boolean,
  hideOptionalLabel: boolean,
  noLeftMargin?: boolean,
  noRightMargin?: boolean,
};

const Field = (props: Props) => {
  let className = applyModifiers(STYLE_PREFIX, props.modifiers);
  let containerClassName = `${STYLE_PREFIX}__container ${className}`;
  let labelClassName = `${STYLE_PREFIX}__label`;

  if (props.floatLabel) {
    className += ' js-field-floatlabel';
  }

  if (props.hiddenLabel) {
    className += ' c-field--label-hidden';
    labelClassName += ' u-hidden';
  }

  if (props.noLeftMargin) {
    containerClassName += ` ${STYLE_PREFIX}__container--noLeftMargin`;
  }

  if (props.noRightMargin) {
    containerClassName += ` ${STYLE_PREFIX}__container--noRightMargin`;
  }

  const hasValue = React.Children.map(
    props.children,
    child => child && child.props && child.props.value
  ).some(bool => bool);

  if (hasValue || props.active) {
    className += ` ${ACTIVE_CLASS}`;
  }

  if (props.touched && props.invalid) {
    className += ` ${INVALID_CLASS}`;
  }

  const optionalText = props.intl.formatMessage(messages.optional);
  const label = props.label && (
    <label className={labelClassName} htmlFor={props.id}>
      <span>{props.label}</span>
      &nbsp;
      {!props.required && !props.hideOptionalLabel && (
        <em className="c-field__optional" title={optionalText}>
          {optionalText}
        </em>
      )}
    </label>
  );

  return (
    <div className={containerClassName}>
      {label}
      <div className={className}>{props.children}</div>
    </div>
  );
};

export default injectIntl(Field);
